import { render, staticRenderFns } from "./ModalContentSettingsPopup.vue?vue&type=template&id=1a0d0d52"
import script from "./ModalContentSettingsPopup.vue?vue&type=script&lang=js"
export * from "./ModalContentSettingsPopup.vue?vue&type=script&lang=js"
import style0 from "./ModalContentSettingsPopup.vue?vue&type=style&index=0&id=1a0d0d52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Picture: require('/vercel/path0/components/elements/Picture.vue').default})
